/*
 * WPMLHelper - support for language toggle popup
 */

export default class WPMLHelper {
    constructor() {
        // show switch warning popup
        $('.language-toggle').on('click', function onClick() {
            const $this = $(this);
            if ($this.data('missing')) {
                let url = $('a', $this).attr('href');
                const code = $this.data('code');
                url = url || `/${code}/`;
                const $modal = $('#language').modal('show');
                if (!$modal.length) {
                    return null;
                }
                $('.js-btn-continue', $modal).attr('href', url);

                $('.js-btn-cancel', $modal).on('click', () => {
                    $modal.modal('hide');
                    return false;
                });

                return false;
            }
            return null;
        });
    }
}
